import { axios } from '@/utils/axios';

const RESOURCE_NAME  = '/flat-notes';

export default {
    get_all(payload) {
        return axios.get(`${RESOURCE_NAME}/`, {params: {person_hash: payload}})
    },
    get_count(payload) {
        return axios.get(`${RESOURCE_NAME}/count`, {params: {person_hash: payload}})
    },
    create(payload) {
        return axios.post(`${RESOURCE_NAME}/`, payload)
    },
    update(payload) {
        return axios.post(`${RESOURCE_NAME}/update`, payload)
    },
    remove(payload) {
        return axios.post(`${RESOURCE_NAME}/remove`, { "flat_note_id": payload })
    }
};